import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '../../types';

const renderInputStyles = makeStyles((theme: Theme) => ({
    minWidth160px: {
        minWidth: '160px'
    },
    minWidth120px: {
        minWidth: '140px'
    },
    adornedStyle: {
        '& > .MuiOutlinedInput-adornedEnd': {
            paddingRight: 4
        },
        '& > .MuiOutlinedInput-adornedStart': {
            paddingLeft: 4
        }
    },
    width100: {
        width: '100%'
    },
    height100: {
        height: '100%'
    },
    roundCheckbox: {
        '& svg': {
            width: '16px',
            height: '16px'
        }
    },
    formControl: {
        justifyContent: 'flex-end'
    },
    year: {
        '& h6': {
            fontSize: '18px !important'
        },
        '& .Mui-selected': {
            backgroundColor: `${theme.palette.secondary.main} !important`
        }
    },
    option: {
        padding: 0
    },
    listbox: {
        padding: '2px 8px'
    },
    paddingIcon: {
        '& button': {
            padding: '12px'
        }
    },
    redStarClass: {
        color: theme.palette.error.main
    },
    width1Spacing: {
        width: theme.spacing(1)
    }
}));

export default renderInputStyles;
